module.exports = __webpack_public_path__ + "static/media/gu.c3db56a6.svg";